module.exports = __webpack_public_path__ + "static/img/chart-pic1.32af45d2.png";